import HTTP from '.';
import CalendarServiceMock from './mocks/CalendarService.mock';
import config from '@/config';

export default class CalendarService {
  static getCalendarSummary(args) {
    if (config.ENV.MOCK === true) {
      return CalendarServiceMock.getCalendarSummary(args);
    }

    return HTTP.get(
      `/api/currentmember/calendars/summary?from=${
        args.startDate
      }&to=${
        args.endDate}`,
    );
  }
}
